<template>
    <div
        ref="scrollList"
        :style="{ backgroundColor: colors.messageList.bg }"
        class="sc-message-list"
        @scroll="handleScroll"
    >
        <Message
            v-for="(message, idx) in filteredMessages"
            :id="`sc-message_${$_.get(message, 'id') || $_.get(message, 'raw.uniqMessageId') || idx}`"
            :key="`sc-message_${$_.get(message, 'id') || $_.get(message, 'raw.uniqMessageId') || idx}`"
            :colors="colors"
            :is-chat-window="ischatwindow"
            :is-private-chat="isPrivateChat"
            :is-colored="isColored"
            :message="message"
            :random-bg-color-with-name="randomBgColorWithName"
            :showAvatar="showAvatar"
            :user="profile(message)"
            @remove="$emit('remove', message)"
            @reply-comment-action="$emit('reply-comment-action', $event)"
            @open-gallery="handleOpenGallery"
            :disable-translation="disableTranslation"
            :is-whatsapp="isWhatsapp"
            :channel-id="channelId"
            :contextMenu="$_.get(message, 'raw.isVisible', contextMenuVisable) && contextMenuVisable"
            :context-menu-only-create-task="contextMenuOnlyCreateTask"
            :user-message-color="computedUserMessageColor"
            :debugModeEnabled="debugModeEnabled"
            :class="{
                hiddenMessage: isOwnedByRequestUser ? false : !$_.get(message, 'raw.isVisible', true),
            }"
            :visitorId="visitorId"
        >
            {{ message }}
            <template v-slot:user-avatar="scopedProps">
                <slot :message="scopedProps.message" :user="scopedProps.user" name="user-avatar"></slot>
            </template>
            <template v-slot:text-message-body="scopedProps">
                <slot
                    :me="scopedProps.me"
                    :message="scopedProps.message"
                    :messageColors="scopedProps.messageColors"
                    :messageText="scopedProps.messageText"
                    name="text-message-body"
                >
                </slot>
            </template>
            <template v-slot:text-message-toolbox="scopedProps">
                <slot :me="scopedProps.me" :message="scopedProps.message" name="text-message-toolbox"></slot>
            </template>
        </Message>
        <div v-if="newMsg && ischatwindow" class="newMsg" @click="_scrollDown">
            <md-icon>expand_more</md-icon>
        </div>

        <ChatMediaGallery
            :visible.sync="galleryVisible"
            :items="galleryItemsForOverlay"
            :initial-index="initialGalleryIndex"
            :show-go-to-message="true"
            @go-to-message="onGalleryGoToMessage"
        />
    </div>
</template>

<script>
import { socketMessageStream } from "../../utils/socketStream";
import { filter } from "rxjs/operators";
import { mapState } from "vuex";

import Message from "./Message.vue";
import ChatMediaGallery from "./ChatMediaGallery.vue";
import chatIcon from "./assets/chat-icon.svg";
import _ from "lodash";

export default {
    name: "MessageList",
    components: {
        Message,
        ChatMediaGallery,
    },
    props: {
        visitorId: {
            type: String,
            required: false,
        },
        contactOwner: {
            type: String,
            required: false,
        },
        shouldScroll: {
            type: Boolean,
            required: false,
            default: true,
        },
        disableTranslation: {
            type: Boolean,
            default: false,
            required: false,
        },
        ischatwindow: {
            type: Boolean,
            default: false,
        },
        participants: {
            type: Array,
            required: true,
        },
        messages: {
            type: Array,
            required: true,
        },
        colors: {
            type: Object,
            required: true,
        },
        alwaysScrollToBottom: {
            type: Boolean,
            required: true,
        },
        scrollTop: {
            type: Boolean,
            required: false,
            default: false,
        },
        showAvatar: {
            type: Boolean,
            required: false,
            default: false,
        },
        randomBgColorWithName: {
            type: Boolean,
            required: false,
            default: false,
        },
        isColored: {
            type: Boolean,
            default: false,
            required: false,
        },
        isPrivateChat: {
            type: Boolean,
            default: false,
            required: false,
        },
        isWhatsapp: {
            type: Boolean,
            default: false,
            required: false,
        },
        channelId: {
            type: String,
            required: false,
        },
        contextMenuVisable: {
            type: Boolean,
            default: true,
            required: false,
        },
        /** true ise sağ tık menüsünde sadece "Görev oluştur" seçeneği gösterilir (örn. Archives) */
        contextMenuOnlyCreateTask: {
            type: Boolean,
            default: false,
            required: false,
        },
        debugModeEnabled: {
            type: Boolean,
            default: false,
            required: false,
        },
        showChatbotPrivate: {
            type: Boolean,
            default: false,
            required: false,
        },
    },

    data() {
        return {
            newMsg: false,
            isScrolled: false,
            sub: null,
            galleryVisible: false,
            galleryFrozenItems: null,
            initialGalleryIndex: 0,
            gallerySuppressAutoScrollUntil: 0,
            bgColorList: [
                "#9370DB",
                "#FFD700",
                "#FF6347",
                "#00CED1",
                "#9370DB",
                "#40E0D0",
                "#FF4500",
                "#6A5ACD",
                "#87CEEB",
                "#FF69B4",
                "#20B2AA",
                "#FFA07A",
                "#00FF7F",
                "#8A2BE2",
                "#FF6347",
            ],
            textColorList: [
                "#333333",
                "#333333",
                "#FFFFFF",
                "#333333",
                "#FFFFFF",
                "#333333",
                "#FFFFFF",
                "#FFFFFF",
                "#333333",
                "#333333",
                "#333333",
                "#333333",
                "#333333",
                "#FFFFFF",
                "#FFFFFF",
            ],
            userList: [],
        };
    },
    methods: {
        sentColorsStyle() {
            const colorIndex = this.getUserColorIndex();
            return {
                color: this.textColorList[colorIndex % this.textColorList.length],
                backgroundColor: this.bgColorList[colorIndex % this.bgColorList.length],
            };
        },
        getUserColorIndex() {
            this.getUserList();
            const userIndex = this.userList.findIndex((user) => user._id === this.user._id);
            return userIndex % this.bgColorList.length;
        },
        receivedColorsStyle() {
            return {
                color: this.colors.receivedMessage.text,
                backgroundColor: this.colors.receivedMessage.bg,
            };
        },
        getUserList() {
            const messageList = this.messages.filter(
                (message) => typeof message.type !== "undefined" && message.type === "text"
            );
            const message = messageList[messageList.length - 1];
            const conversationId = message?.raw?.conversation;
            const conversation = this.chats.find((chat) => chat._id === conversationId);

            if (conversation?.meta?.chatType === "team") {
                this.userList = this.users;
            } else if (this.selectedChat && this.selectedChat.meta && this.selectedChat.meta?.department) {
                this.userList = this.users.filter((user) => {
                    return user.subjects.includes(this.selectedChat.meta?.department._id) || user.subjects.length === 0;
                });

                this.userList = this.userList.map((user) => {
                    return {
                        ...user,
                    };
                });
            } else if (conversation?.meta?.chatType === "groupThread") {
                this.userList = conversation.meta?.groupThread.agents.reduce(
                    (result, agent) => {
                        result.push(agent);
                        return result;
                    },
                    [conversation.meta?.groupThread.creator]
                );
            }
        },

        _scrollDown() {
            if (this.$refs.scrollList) {
                this.$refs.scrollList.scrollTop = this.$refs.scrollList.scrollHeight;
                this.newMsg = false;
                this.isScrolled = false;
            }
        },
        handleScroll(e) {
            if (this.shouldScroll) {
                if (e.target.scrollTop === 0) {
                    this.$emit("scrollToTop");
                }
                if (
                    !!this.$refs.scrollList &&
                    this.$refs.scrollList.scrollTop >
                        this.$refs.scrollList.scrollHeight - this.$refs.scrollList.offsetHeight - 100
                ) {
                    this.newMsg = false;
                    this.isScrolled = false;
                } else {
                    this.isScrolled = true;
                    if (!this.newMsg) this.newMsg = true;
                }
            }
        },
        shouldScrollToBottom() {
            if (this.alwaysScrollToBottom) {
                return (
                    (this.alwaysScrollToBottom ||
                        (!!this.$refs.scrollList &&
                            this.$refs.scrollList.scrollTop >
                                this.$refs.scrollList.scrollHeight - this.$refs.scrollList.offsetHeight - 100)) &&
                    (!this.isScrolled || !this.ischatwindow)
                );
            }
        },
        profile(message) {
            return { _id: message.raw?.user?._id || message.raw?.userId, name: message.author };
        },
        handleOpenGallery(message) {
            var list = this.chatGalleryOverlayItems;
            var overlayIdx = list.findIndex(function (it) {
                return it.chatMessage === message;
            });
            if (overlayIdx < 0) {
                var uniqId = _.get(message, "raw.uniqMessageId");
                var msgId = _.get(message, "id");
                var rawId = _.get(message, "raw._id");
                overlayIdx = list.findIndex(function (it) {
                    var m = it.chatMessage;
                    return (
                        (uniqId && _.get(m, "raw.uniqMessageId") === uniqId) ||
                        (msgId != null && _.get(m, "id") === msgId) ||
                        (rawId && _.get(m, "raw._id") === rawId)
                    );
                });
            }
            this.galleryFrozenItems = this.chatGalleryOverlayItems.slice();
            this.initialGalleryIndex = overlayIdx >= 0 ? overlayIdx : 0;
            this.galleryVisible = true;
        },
        getGalleryFileName(message) {
            if (!message) return "";
            if (message.isMail) return _.get(message, "name") || "Dosya";
            if (message.type === "chatbot-image") return "ChatBot Image";
            if (message.type === "chatbot-file") {
                var fileUrl = _.get(message, "raw.payload.fileUrl") || _.get(message, "raw.payload") || "";
                var parts = String(fileUrl).split("/");
                var last = parts[parts.length - 1] || "";
                var qIdx = last.indexOf("?");
                if (qIdx !== -1) last = last.substring(0, qIdx);
                return last || "ChatBot File";
            }
            return _.get(message, "raw.asset.name") || _.get(message, "data.text") || "Dosya";
        },
        getGalleryItemSrc(message) {
            if (!message) return null;
            if (message.type === "chatbot-image") {
                return _.get(message, "raw.payload.imageUrl") || _.get(message, "raw.payload") || null;
            }
            if (message.type === "chatbot-file") {
                return _.get(message, "raw.payload.fileUrl") || _.get(message, "raw.payload") || null;
            }
            var asset = message.isMail ? message : _.get(message, "raw.asset");
            if (!asset) return null;
            var path = asset.path || "";
            if (!path) return null;
            var isExternal = ["whatsapp", "instagram", "messenger", "telegram", "facebook", "linkedin", "tables/attachments", "unipile", "chat", "api-messages"].some(function(k) {
                return path.indexOf(k) !== -1;
            });
            if (isExternal) return "https://static.supsis.live/" + path;
            if (asset.v2Format && asset.cdnUrl) return asset.cdnUrl;
            return "https://static.supsis.live/" + path + asset._id + (asset.ext ? "." + asset.ext : "");
        },
        onGalleryGoToMessage: function (payload) {
            var message = payload && payload.message;
            var scrollTarget = payload && payload.scrollTarget;
            if (scrollTarget) {
                this.gallerySuppressAutoScrollUntil = Date.now() + 900;
                this.galleryVisible = false;
                var self = this;
                this.$nextTick(function () {
                    self.$nextTick(function () {
                        self.scrollChatToMessageByIds(scrollTarget);
                    });
                });
                return;
            }
            if (!message) return;
            this.gallerySuppressAutoScrollUntil = Date.now() + 900;
            this.galleryVisible = false;
            var self2 = this;
            this.$nextTick(function () {
                self2.$nextTick(function () {
                    self2.scrollChatToMessage(message);
                });
            });
        },
        getMessageListDomId: function (message) {
            if (!message) return null;
            var idx = this.filteredMessages.indexOf(message);
            if (idx < 0) {
                var uniqId = _.get(message, "raw.uniqMessageId");
                var msgId = _.get(message, "id");
                var rawId = _.get(message, "raw._id");
                idx = _.findIndex(this.filteredMessages, function (m) {
                    if (uniqId && _.get(m, "raw.uniqMessageId") === uniqId) return true;
                    if (msgId != null && _.get(m, "id") === msgId) return true;
                    if (rawId && _.get(m, "raw._id") === rawId) return true;
                    return false;
                });
            }
            if (idx < 0) return null;
            var row = this.filteredMessages[idx];
            var part = _.get(row, "id") || _.get(row, "raw.uniqMessageId") || idx;
            return "sc-message_" + part;
        },
        scrollChatToMessageByIds: function (scrollTarget) {
            var uniqMessageId = scrollTarget && scrollTarget.uniqMessageId;
            var messageId = scrollTarget && scrollTarget.messageId;
            if (!uniqMessageId && !messageId) return;
            var found = _.find(this.filteredMessages, function (m) {
                if (uniqMessageId && _.get(m, "raw.uniqMessageId") === uniqMessageId) return true;
                if (messageId && String(_.get(m, "raw._id")) === String(messageId)) return true;
                return false;
            });
            if (!found) {
                if (this.$message) this.$message.warning("Mesaj sohbet listesinde bulunamadı.");
                return;
            }
            this.gallerySuppressAutoScrollUntil = Date.now() + 900;
            this.scrollChatToMessage(found);
        },
        scrollChatToMessage: function (message) {
            var domId = this.getMessageListDomId(message);
            if (!domId) {
                if (this.$message) this.$message.warning("Mesaj sohbet listesinde bulunamadı.");
                return;
            }
            var el = document.getElementById(domId);
            var container = this.$refs.scrollList;
            if (!el || !container) {
                if (this.$message) this.$message.warning("Mesaj sohbet listesinde bulunamadı.");
                return;
            }
            el.classList.remove("gallery-jump-highlight");
            void el.offsetWidth;
            el.classList.add("gallery-jump-highlight");
            window.setTimeout(function () {
                el.classList.remove("gallery-jump-highlight");
            }, 2200);
            try {
                el.scrollIntoView({ block: "center", behavior: "smooth" });
            } catch (err) {
                var rectEl = el.getBoundingClientRect();
                var rectC = container.getBoundingClientRect();
                var delta = rectEl.top - rectC.top - (container.clientHeight / 2 - rectEl.height / 2);
                container.scrollTop = container.scrollTop + delta;
            }
        },
    },
    computed: {
        ...mapState({
            activeConversation: (state) => state.contact.selectedContact?.lastConversation,
            lastPrivateMessage: (state) => state.app.lastPrivateChat,
            unreadCount: (state) => state.app.unreadPrivateChatCount,
            users: (state) => state.user.users.data,
            chats: (state) => state.team.chats,
            selectedChat: (state) => state.team.selectedChat,
            user: (state) => state.auth.user,
            hideSystemMessages: (state) => state.app.hideSystemMessages,
        }),
        computedUserMessageColor() {
            return this.sentColorsStyle();
        },
        defaultChatIcon() {
            return chatIcon;
        },
        isOwnedByRequestUser() {
            return this.contactOwner ? this.contactOwner === this.$store.state.auth.user?._id : false;
        },
        filteredMessages() {
            if (this.hideSystemMessages) {
                return this.messages.filter((message) => {
                    const messageType = message.raw?.messageType;
                    if (messageType === "chatbot-private" && this.showChatbotPrivate) return true;
                    return messageType !== "system" && messageType !== "chatbot-private";
                });
            }
            return this.messages;
        },
        galleryMedia() {
            var self = this;
            return this.filteredMessages.filter(function(msg) {
                if (_.get(msg, "raw.isDeleted")) return false;
                if (!self.getGalleryItemSrc(msg)) return false;
                if (msg.type === "image" || msg.type === "video" || msg.type === "asset" || msg.type === "audio") {
                    return true;
                }
                if (msg.type === "chatbot-image" || msg.type === "chatbot-file") {
                    return true;
                }
                var mime = _.get(msg, "raw.asset.mime", "") || "";
                var ext = (_.get(msg, "raw.asset.ext", "") || "").toLowerCase();
                var videoExts = ["mp4", "webm", "mov", "avi", "mkv", "m4v"];
                var audioExts = ["mp3", "wav", "ogg", "m4a", "aac", "opus", "flac", "oga", "amr", "mpeg"];
                if (mime.indexOf("video") !== -1 || videoExts.indexOf(ext) !== -1) return true;
                if (mime.indexOf("audio") !== -1 || audioExts.indexOf(ext) !== -1) return true;
                var k;
                for (k = 0; k < audioExts.length; k++) {
                    if (mime.indexOf(audioExts[k]) !== -1) return true;
                }
                return false;
            });
        },
        galleryItemsForOverlay() {
            if (this.galleryVisible && this.galleryFrozenItems && this.galleryFrozenItems.length) {
                return this.galleryFrozenItems;
            }
            return this.chatGalleryOverlayItems;
        },
        chatGalleryOverlayItems() {
            var self = this;
            return this.galleryMedia
                .map(function (m) {
                    var url = self.getGalleryItemSrc(m);
                    var mime = (_.get(m, "raw.asset.mime", "") || "").toLowerCase();
                    var ext = (_.get(m, "raw.asset.ext", "") || "").toLowerCase();
                    if (m.type === "chatbot-image" && !mime) {
                        mime = "image/png";
                    }
                    if (m.type === "chatbot-file" && !mime && url) {
                        var urlLower = String(url).toLowerCase();
                        var dotIdx = urlLower.lastIndexOf(".");
                        if (dotIdx !== -1) {
                            ext = urlLower.substring(dotIdx + 1).split("?")[0] || "";
                        }
                    }
                    return {
                        url: url,
                        name: self.getGalleryFileName(m),
                        mime: mime,
                        ext: ext,
                        messageType: m.type,
                        chatMessage: m,
                    };
                })
                .filter(function (x) {
                    return !!x.url;
                });
        },
    },
    mounted() {
        if (!this.scrollTop && !this.isScrolled) {
            this.$nextTick(this._scrollDown());
        }
        if (!this.ischatwindow && !this.isPrivateChat) {
            this.sub = socketMessageStream
                .pipe(
                    filter(
                        (x) =>
                            ["visitor", "user"].includes(_.get(x, "data.messageType")) &&
                            this.activeConversation !== null &&
                            x.data.conversationId === this.activeConversation._id
                    )
                )
                .subscribe(() => {
                    if (this.isScrolled) this.newMsg = true;
                });
        }
    },
    updated() {
        if (Date.now() < this.gallerySuppressAutoScrollUntil) return;
        if (this.shouldScrollToBottom()) this.$nextTick(this._scrollDown());
    },
    beforeDestroy() {
        if (this.sub) this.sub.unsubscribe();
    },
    watch: {
        messages(newVal) {
            if (newVal) {
                this.getUserList();
            }
        },
        galleryVisible: function (val) {
            if (!val) {
                this.galleryFrozenItems = null;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.sc-message-list {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    background-size: 100%;
    padding: 40px 12px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .hiddenMessage {
        content: "";
        filter: blur(10px);
        user-select: none;
    }

    .newMsg {
        position: absolute;
        bottom: 10px;
        right: 10px;
        z-index: 2;
        padding: 2.5px;
        border-radius: 50%;
        background-color: #22272d;
        cursor: pointer;

        .md-icon.md-theme-default.md-icon-font {
            color: #ffffff;
        }
    }

}

.sc-message-wrapper.gallery-jump-highlight {
    outline: 2px solid #00a5f4;
    outline-offset: 3px;
    border-radius: 8px;
    transition: outline 0.25s ease;
}
</style>
